import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import PageContent from '~/common/layout/PageContent';
import PageContentWrapper from '~/common/layout/PageContentWrapper';

import SideMenu from '../containers/common/SideMenu';
import OrgUserHeader from '~/apps/shared/containers/users/OrgUserHeader';
import OrgUserList from '~/apps/shared/containers/users/OrgUserList';


export default function (params) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <OrgUserHeader orgId={params.orgId} />
          <PageContentWrapper>
            <OrgUserList orgId={params.orgId} />
          </PageContentWrapper>
        </PageContent>
      </PageWrapper>
    </React.Fragment>
  );
};
